module.exports = __webpack_public_path__ + "static/img/lp.3537292.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/lp.jpg
// module id = sDap
// module chunks = 0